import React from 'react';
import classNames from 'classnames';
import {Image} from 'semantic-ui-react';

import {Button, Layouts, Form} from '@components';
import constants from '@constants';
import {Props} from './types';

import './index.scss';

const Help: React.FC<Props> = props => {
  const isAuthed = props.me.sub;

  return (
    <div className={classNames('a__csv-help', {after: isAuthed})}>
      {!isAuthed && (
        <Layouts.Header.Before
          history={props.history}
          location={props.location}
          match={props.match}
        />
      )}
      <div className="b__title-header">
        <Button.GoBack history={props.history} />
        ユーザーインポートについて
      </div>

      <div className="b__csv-helps">
        <div className="w__introduction">
          <div className="b__csv-help-header">サンプルCSVについて</div>
          <div>
            以下の記入例を参考に、インポートしたいユーザーを入力してください。
          </div>
          <div className="b__image">
            <div className="w__section">
              <span>※</span>
              <Form.Label text="記入例" />
            </div>
            <Image src={constants.IMAGES.SAMPLE_ROW} />
          </div>
        </div>
        <div className="w__introduction">
          <div className="b__csv-help-header">CSV入力項目について</div>
          <div>
            表の「入力項目」と「入力制約」に従った作成したCSVファイルを使用してください。
          </div>
        </div>
        <div className="w__table">
          <div className="b__rule-box">
            <table className="csv-rule">
              <thead>
                <tr>
                  <th>入力項目</th>
                  <th>入力制約</th>
                  <th>必須</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>姓</td>
                  <td>50文字以内</td>
                  <td>◯</td>
                </tr>
                <tr className="bcg">
                  <td>名</td>
                  <td>50文字以内</td>
                  <td>◯</td>
                </tr>
                <tr>
                  <td>セイ</td>
                  <td>50文字以内の全角カナ</td>
                  <td>◯</td>
                </tr>
                <tr className="bcg">
                  <td>メイ</td>
                  <td>50文字以内の全角カナ</td>
                  <td>◯</td>
                </tr>
                <tr>
                  <td>メールアドレス</td>
                  <td>50文字以内のメールアドレスフォーマット</td>
                  <td>◯</td>
                </tr>
                <tr className="bcg">
                  <td>携帯番号</td>
                  <td>11桁の半角数字 (ハイフンあり 例: 080-1111-2222)</td>
                  <td>×</td>
                </tr>
                <tr>
                  <td>地域</td>
                  <td>
                    半角英数字 0 (北海道) 〜 46 (沖縄)
                    <br />
                    対応数字は「地域一覧」を参照
                  </td>
                  <td>◯</td>
                </tr>
                <tr className="bcg">
                  <td>権限</td>
                  <td>
                    半角英数字 0 (一般ユーザー) 又は1(管理者)
                    <br />
                    2(特権管理者)
                  </td>
                  <td>◯</td>
                </tr>
                <tr>
                  <td>生年月日</td>
                  <td>8桁の半角数字 (ハイフンあり 例: 2020-01-01)</td>
                  <td>×</td>
                </tr>
                <tr className="bcg">
                  <td>性別</td>
                  <td>半角英数字 1(男性) 2(女性) 3(その他)</td>
                  <td>×</td>
                </tr>
                <tr>
                  <td>所属組織</td>
                  <td>30文字以内</td>
                  <td>×</td>
                </tr>
                <tr className="bcg">
                  <td>役職</td>
                  <td>30文字以内</td>
                  <td>×</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="w__introduction">
          <div className="b__csv-help-header">CSVフォーマットについて</div>
          <div>
            ユーザーをインポートする際の「地域」と「権限」カラムは以下の
            「地域一覧」と「権限一覧」にある対象の「番号」を入力してください。
          </div>
        </div>
        <div className="w__index-table">
          <div className="b__two-box">
            <div className="table-header">地域一覧</div>
            <div className="b__prefecture-box">
              <div className="table-box">
                <table className="csv-prefecture">
                  <thead>
                    <tr>
                      <th>都道府県</th>
                      <th>番号</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>北海道</td>
                      <td className="number">0</td>
                    </tr>
                    <tr className="bcg">
                      <td>青森県</td>
                      <td className="number">1</td>
                    </tr>
                    <tr>
                      <td>岩手県</td>
                      <td className="number">2</td>
                    </tr>
                    <tr className="bcg">
                      <td>宮城県</td>
                      <td className="number">3</td>
                    </tr>
                    <tr>
                      <td>秋田県</td>
                      <td className="number">4</td>
                    </tr>
                    <tr className="bcg">
                      <td>山形県</td>
                      <td className="number">5</td>
                    </tr>
                    <tr>
                      <td>福島県</td>
                      <td className="number">6</td>
                    </tr>
                    <tr className="bcg">
                      <td>茨城県</td>
                      <td className="number">7</td>
                    </tr>
                    <tr>
                      <td>栃木県</td>
                      <td className="number">8</td>
                    </tr>
                    <tr className="bcg">
                      <td>群馬県</td>
                      <td className="number">9</td>
                    </tr>
                    <tr>
                      <td>埼玉県</td>
                      <td>10</td>
                    </tr>
                    <tr className="bcg">
                      <td>千葉県</td>
                      <td>11</td>
                    </tr>
                    <tr>
                      <td>東京都</td>
                      <td>12</td>
                    </tr>
                    <tr className="bcg">
                      <td className="prefecture-font">神奈川県</td>
                      <td>13</td>
                    </tr>
                    <tr>
                      <td>新潟県</td>
                      <td>14</td>
                    </tr>
                    <tr className="bcg">
                      <td>富山県</td>
                      <td>15</td>
                    </tr>
                    <tr>
                      <td>石川県</td>
                      <td>16</td>
                    </tr>
                    <tr className="bcg">
                      <td>福井県</td>
                      <td>17</td>
                    </tr>
                    <tr>
                      <td>山梨県</td>
                      <td>18</td>
                    </tr>
                    <tr className="bcg">
                      <td>長野県</td>
                      <td>19</td>
                    </tr>
                    <tr>
                      <td>岐阜県</td>
                      <td>20</td>
                    </tr>
                    <tr className="bcg">
                      <td>静岡県</td>
                      <td>21</td>
                    </tr>
                    <tr>
                      <td>愛知県</td>
                      <td>22</td>
                    </tr>
                    <tr className="bcg">
                      <td>三重県</td>
                      <td>23</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div>
                <table className="csv-prefecture">
                  <thead>
                    <tr>
                      <th>都道府県</th>
                      <th>番号</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>滋賀県</td>
                      <td>24</td>
                    </tr>
                    <tr className="bcg">
                      <td>京都府</td>
                      <td>25</td>
                    </tr>
                    <tr>
                      <td>大阪府</td>
                      <td>26</td>
                    </tr>
                    <tr className="bcg">
                      <td>兵庫県</td>
                      <td>27</td>
                    </tr>
                    <tr>
                      <td>奈良県</td>
                      <td>28</td>
                    </tr>
                    <tr className="bcg">
                      <td className="prefecture-font">和歌山県</td>
                      <td>29</td>
                    </tr>
                    <tr>
                      <td>鳥取県</td>
                      <td>30</td>
                    </tr>
                    <tr className="bcg">
                      <td>島根県</td>
                      <td>31</td>
                    </tr>
                    <tr>
                      <td>岡山県</td>
                      <td>32</td>
                    </tr>
                    <tr className="bcg">
                      <td>広島県</td>
                      <td>33</td>
                    </tr>
                    <tr>
                      <td>山口県</td>
                      <td>34</td>
                    </tr>
                    <tr className="bcg">
                      <td>徳島県</td>
                      <td>35</td>
                    </tr>
                    <tr>
                      <td>香川県</td>
                      <td>36</td>
                    </tr>
                    <tr className="bcg">
                      <td>愛媛県</td>
                      <td>37</td>
                    </tr>
                    <tr>
                      <td>高知県</td>
                      <td>38</td>
                    </tr>
                    <tr className="bcg">
                      <td>福岡県</td>
                      <td>39</td>
                    </tr>
                    <tr>
                      <td>佐賀県</td>
                      <td>40</td>
                    </tr>
                    <tr className="bcg">
                      <td>長崎県</td>
                      <td>41</td>
                    </tr>
                    <tr>
                      <td>熊本県</td>
                      <td>42</td>
                    </tr>
                    <tr className="bcg">
                      <td>大分県</td>
                      <td>43</td>
                    </tr>
                    <tr>
                      <td>宮崎県</td>
                      <td>44</td>
                    </tr>
                    <tr className="bcg">
                      <td className="prefecture-font">鹿児島県</td>
                      <td>45</td>
                    </tr>
                    <tr>
                      <td>沖縄県</td>
                      <td>46</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="b__gender-table-box">
              <div className="table-header">性別一覧</div>
              <table className="csv-gender">
                <thead>
                  <tr>
                    <th>性別</th>
                    <th>番号</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>男性</td>
                    <td>1</td>
                  </tr>
                  <tr className="gender-bcg">
                    <td>女性</td>
                    <td>2</td>
                  </tr>
                  <tr>
                    <td>その他</td>
                    <td>3</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="b__authority-table">
            <div className="table-header">権限一覧</div>
            <div>
              <table className="csv-authority">
                <thead>
                  <tr>
                    <th>権限</th>
                    <th>番号</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>一般ユーザー</td>
                    <td>0</td>
                  </tr>
                  <tr className="authority-bcg">
                    <td>管理者</td>
                    <td>1</td>
                  </tr>
                  <tr>
                    <td>特権管理者※</td>
                    <td>2</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              ※特権管理者は追加することができません。(既存の特権管理者のユーザー情報の変更は可能)
              <br />
              また、既存の特権管理者の権限を変更することはできません。
            </div>
          </div>
        </div>
        <div className="w__introduction">
          <div className="b__csv-help-header">登録時の注意事項</div>
          <div>
            <ul>
              <li>
                <b>
                  チームに登録済みのメールアドレスを持つユーザーをインポートした場合、ユーザー情報の変更を行います。
                </b>
              </li>
            </ul>
          </div>
          <div>
            CSVのフォーマットが以下に当てはまる場合、ユーザーの登録が行えません。
          </div>
          <ul>
            <li>
              <b>既に管理者として使用されているメールアドレスがある場合</b>
            </li>
            <li>
              一般ユーザー/管理者の登録 /
              更新時共に、チーム内で携帯番号の重複がある場合
            </li>
            <li>「CSV入力項目について」の入力制約を満たさない場合</li>
            <li>CSV内でメールアドレス、携帯番号が重複する場合</li>
            <li>プランの上限人数を超えている場合</li>
            <li>特権管理者を追加しようとした場合</li>
            <li>特権管理者に対して権限変更を行おうとした場合</li>
          </ul>
        </div>
        {!isAuthed && <Layouts.Footer.Main />}
      </div>
    </div>
  );
};

export default Help;
